<clare-main-content-container [isNavNeeded]="false">
    <ng-container mainContent>
        <ng-container *ngIf="user$ | async as user">
            <ng-container *ngxPermissionsExcept="['viewCustomerPortal']">
                <div class="redesign-content-container theme-v2" *letVar="project$ | async as project">
                    <div class="header-container">
                        <div class="content-container">
                            <div class="header">
                                <div class="header__left">
                                    <!-- welcome text -->
                                    <div class="welcome">
                                        <span class="welcome__top">Welcome!</span>
                                        <span class="welcome__bottom">{{ getDisplayName(user$ | async) }}</span>
                                    </div>

                                    <!-- create-account button -->
                                    <div>
                                        <a [routerLink]="addAccountRoute">
                                            <button class="create-button" mat-flat-button>
                                                <div style="display: flex; text-align: center">
                                                    <span style="margin-right: 0.25rem">+</span>
                                                    <span>Create Account</span>
                                                </div>
                                            </button>
                                        </a>
                                    </div>
                                </div>

                                <span class="spacer"></span>

                                <div class="header__right">
                                    <!-- search bar -->
                                    <account-search (search)="onSearch($event)" [filters]="filters"></account-search>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="scrollable-content">
                        <div class="content-container">
                            <div class="summary-section" *ngxPermissionsOnly="['viewProject', 'editProject']">
                                <!-- account summary -->
                                <div class="summary">
                                    <div class="summary__left">
                                        <div class="summary__total">
                                            <span class="summary__total-count">{{ totals.accounts }}</span>
                                            <span class="summary__total-subtitle">Total Accounts</span>
                                        </div>
                                    </div>
                                    <div class="summary__right">
                                        <div class="summary__subtotal">
                                            <span class="summary__icon" [style.color]="getOnlineStatusColor('offline')">●</span>
                                            <a [routerLink]="accountListRoute" [queryParams]="{ status: 'offline' }" class="plain-link">
                                                {{ totals["offline"] }} Offline
                                            </a>
                                        </div>
                                        <div class="summary__subtotal">
                                            <span class="summary__icon" [style.color]="getOnlineStatusColor('unconfigured')">●</span>
                                            <a
                                                [routerLink]="accountListRoute"
                                                [queryParams]="{ status: 'unconfigured' }"
                                                class="plain-link"
                                            >
                                                {{ totals["unconfigured"] }} Unconfigured
                                            </a>
                                        </div>
                                        <div class="summary__subtotal">
                                            <span class="summary__icon" [style.color]="getOnlineStatusColor('online')">●</span>
                                            <a [routerLink]="accountListRoute" [queryParams]="{ status: 'online' }" class="plain-link">
                                                {{ totals["online"] }} Online
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <span class="spacer"></span>

                                <!-- service plan summary -->
                                <div class="summary">
                                    <div class="summary__left">
                                        <div class="summary__total">
                                            <span class="summary__total-count">{{ totals.paidServicePlans }}</span>
                                            <span class="summary__total-subtitle">Paid Service Plans</span>
                                        </div>
                                    </div>
                                    <div class="summary__right">
                                        <div class="summary__subtotal">
                                            <span
                                                class="summary__icon"
                                                [style.color]="getServicePlanColor(servicePlanTiers.INTERACTIVE_PLUS_LTE)"
                                                >●</span
                                            >
                                            <a
                                                [routerLink]="accountListRoute"
                                                [queryParams]="{ 'service-plans': 'interactive plus lte' }"
                                                class="plain-link"
                                            >
                                                {{ totals["Interactive Plus LTE"] }} Interactive Plus LTE
                                            </a>
                                        </div>
                                        <div class="summary__subtotal">
                                            <span
                                                class="summary__icon"
                                                [style.color]="getServicePlanColor(servicePlanTiers.INTERACTIVE_PLUS)"
                                                >●</span
                                            >
                                            <a
                                                [routerLink]="accountListRoute"
                                                [queryParams]="{ 'service-plans': 'interactive plus' }"
                                                class="plain-link"
                                            >
                                                {{ totals["Interactive Plus"] }} Interactive Plus
                                            </a>
                                        </div>
                                        <div class="summary__subtotal">
                                            <span class="summary__icon" [style.color]="getServicePlanColor(servicePlanTiers.INTERACTIVE)"
                                                >●</span
                                            >
                                            <a
                                                [routerLink]="accountListRoute"
                                                [queryParams]="{ 'service-plans': 'interactive' }"
                                                class="plain-link"
                                            >
                                                {{ totals["Interactive"] }} Interactive
                                            </a>
                                        </div>
                                        <div class="summary__subtotal basic">
                                            <span class="summary__icon" [style.color]="getServicePlanColor(servicePlanTiers.BASIC)">●</span>
                                            <a
                                                [routerLink]="accountListRoute"
                                                [queryParams]="{ 'service-plans': 'basic' }"
                                                class="plain-link"
                                            >
                                                {{ totals["Basic"] }} Basic
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="feed">
                                <p class="feed__title">Explore New Features</p>
                                <app-rss-feed-dashboard-widget></app-rss-feed-dashboard-widget>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
</clare-main-content-container>
